"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskySnackbar = void 0;

const material_1 = require("@mui/material");

const react_1 = __importStar(require("react"));

const SskySnackbar = props => {
  const Transition = (0, react_1.useCallback)(transitionsProps => {
    return react_1.default.createElement(material_1.Slide, Object.assign({}, transitionsProps, {
      direction: props.direction
    }));
  }, [props.direction]);
  return react_1.default.createElement(material_1.Snackbar, {
    open: props.open,
    message: props.message,
    key: props.message ? props.message.toString() : "",
    autoHideDuration: props.duration,
    onClose: props.onClose,
    action: props.action,
    anchorOrigin: props.anchorOrigin,
    TransitionComponent: Transition,
    "data-testid": props.dataTestId
  }, props.children);
};

exports.SskySnackbar = SskySnackbar;
SskySnackbar.defaultProps = {
  anchorOrigin: {
    horizontal: "right",
    vertical: "bottom"
  },
  duration: 5000,
  direction: "up"
};
exports.default = react_1.default.memo(SskySnackbar);